import React, { useRef } from 'react';
import classNames from 'classnames';
import styles from './DesktopMenuItem.scss';
import { formatTestId } from '../../../utils/test-id/format-testid';

type DesktopMenuItemProps = {
  label: string;
  url: string;
  active: boolean;
  onSelect: () => void;
  onClose: () => void;
  tabIndex?: number;
  onNavigate?: (direction: string) => void;
  onTabNavigate?: (event: React.KeyboardEvent<HTMLElement>) => void;
  hasChildData?: boolean;
  onLinkClick?: () => void;
  isTouch?: boolean;
};

export const DesktopMenuItem = ({
  label,
  url,
  active,
  onSelect,
  tabIndex = 0,
  onTabNavigate = () => {},
  hasChildData = false,
  onLinkClick,
}: DesktopMenuItemProps) => {
  const handleOnClick = () => {
    onSelect();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Escape') {
      onTabNavigate(e);
      return;
    }

    if (e.key === 'Tab') {
      onTabNavigate(e);
      return;
    }

    if (e.key !== 'Enter') {
      return;
    }

    e.preventDefault();
    onSelect();
  };

  const liRef = useRef(null);

  const cn = classNames(styles.desktopMenuItem, {
    [styles.desktopMenuItem__active]: active,
  });

  const Element = hasChildData ? 'button' : 'a';

  return (
    <li
      className={cn}
      ref={liRef}
      data-testid={formatTestId(label, 'nav-')}
      suppressHydrationWarning
    >
      <Element
        className={classNames(styles.desktopMenuItemLink)}
        href={url}
        onClick={
          !hasChildData
            ? () => {
                onSelect();
                onLinkClick?.();
              }
            : handleOnClick
        }
        onKeyDown={handleKeyDown}
        tabIndex={tabIndex}
        id={formatTestId(label, 'desktop-menu-item-')}
        suppressHydrationWarning
      >
        {label}
      </Element>
    </li>
  );
};
